import type { UserRole } from '~/graphql/graphql';

export type ContactRowData = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  employeeId: string;
  phoneNumber: string;
};

type ContactSourceUser = {
  id: string;
  firstName: string;
  lastName: string;
  externalId?: string | null;
  role: UserRole;
  employeeId?: string | null;
  phoneNumber?: string | null;
};

export function toContactRowData(user: ContactSourceUser): ContactRowData {
  return {
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.externalId ?? '',
    role: user.role,
    employeeId: user.employeeId ?? '',
    phoneNumber: user.phoneNumber ?? '',
  };
}

export type ContactModalState =
  | { mode: 'closed' }
  | { mode: 'new' }
  | { mode: 'edit'; contact: ContactRowData };

export const CLOSED_CONTACT_MODAL: ContactModalState = { mode: 'closed' };

export function contactBeingEdited(
  contactModalState: ContactModalState
): ContactRowData | null {
  return contactModalState.mode === 'edit' ? contactModalState.contact : null;
}
